module.exports = __webpack_public_path__ + "media/img/uploads/press-news-thumb-01-d1c85b89c17f4b59a6e1d04a7e75f42c.jpg";